var exports = {
  "b6": "aligned__4oknKq",
  "hs": "FlexSuiteSubNavSpacer__epz2pK",
  "EP": "twoRows__cLVtUk",
};

module.exports = exports;
